import { ButtonProps } from '@almbrand/button';
import { Modal } from '@almbrand/modal';
import { PageNames } from 'constants/pageNames';
import { usePageParam } from 'hooks/usePageParam';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { displayWarningModal } from 'store/slices/modalSlice';

export interface ReadOnlyWarningModalProps {
	title: string;
	subheading: string;
	actionText: string;
	closeText: string;
	actionButtonType: ButtonProps['buttonType'];
	closeButtonType: ButtonProps['buttonType'];
	reverseButtonOrder: boolean;
	handleActionUrl: { originalString: string };
}

export const ReadOnlyWarningModal: React.FC<ReadOnlyWarningModalProps> = ({
	title,
	subheading,
	actionText,
	closeText,
	actionButtonType,
	closeButtonType,
	reverseButtonOrder,
	handleActionUrl,
}) => {
	const { setPageParam } = usePageParam();

	const dispatch = useAppDispatch();

	const redirectToUrlOrFallback = () => {
		dispatch(displayWarningModal(false));
		if (handleActionUrl?.originalString) {
			window.location.href = handleActionUrl.originalString;
		} else {
			setPageParam(PageNames.StartPage);
		}
	};

	const displayModal = useAppSelector((state) => state.modal.displayWarningModal);

	return (
		<>
			{displayModal && (
				<Modal
					title={title}
					children={subheading}
					handleClose={() => dispatch(displayWarningModal(false))}
					ariaClose='Close'
					closeButtonProps={{
						title: closeText,
						type: closeButtonType,
					}}
					actionButtonProps={{
						title: actionText,
						type: actionButtonType,
						onClick: redirectToUrlOrFallback,
					}}
				/>
			)}
		</>
	);
};
